const AXES = [
  'warmth',
  'futurity',
  'chaos',
  'sacredness',
  'organicness',
  'nostalgia',
  'surrealism',
  'isolation',
  'emotionalSaturation',
  'corporateDensity'
]

const clampMagnitude = (value, limit) => Math.min(limit, Math.max(-limit, value))

export default class VibeEngine {
  constructor() {
    this.vibes = []
  }

  async load(source) {
    const data = typeof source === 'string'
      ? await fetch(source).then(response => response.json())
      : source

    const vibes = Array.isArray(data.vibes) ? data.vibes : []

    this.vibes = vibes.map((vibe, index) => this.createRuntimeVibe(vibe, index))
  }

  createRuntimeVibe(vibe, index) {
    const axes = AXES.reduce((result, key) => {
      result[key] = Number(vibe.axes?.[key] ?? 0)
      return result
    }, {})

    return {
      ...vibe,
      id: vibe.id ?? `vibe-${index}`,
      axes,
      baseX: Number(vibe.x ?? 0),
      baseY: Number(vibe.y ?? 0),
      x: Number(vibe.x ?? 0),
      y: Number(vibe.y ?? 0),
      vx: 0,
      vy: 0,
      radius: 8 + (index % 4),
      driftOffset: index * 0.73,
      waveOffset: index * 1.31
    }
  }

  update(time, deltaTime, fieldState, controls) {
    const step = deltaTime * 60
    const forceX = fieldState?.forcesX ?? []
    const forceY = fieldState?.forcesY ?? []

    this.vibes.forEach((vibe, index) => {
      const ambientScale = 0.05 + controls.driftIntensity * 0.16
      const ambientX = (
        Math.sin(time * 0.16 + vibe.driftOffset) +
        Math.sin(time * 0.07 + vibe.waveOffset) * 0.6
      ) * ambientScale
      const ambientY = (
        Math.cos(time * 0.14 + vibe.waveOffset) +
        Math.sin(time * 0.09 + vibe.driftOffset) * 0.5
      ) * ambientScale

      const homePullX = (vibe.baseX - vibe.x) * 0.0009 * controls.clusterStabilization
      const homePullY = (vibe.baseY - vibe.y) * 0.0009 * controls.clusterStabilization
      const damping = Math.max(0.84, 0.92 - controls.clusterStabilization * 0.025)

      vibe.vx = (vibe.vx + ((forceX[index] || 0) + homePullX + ambientX) * step) * damping
      vibe.vy = (vibe.vy + ((forceY[index] || 0) + homePullY + ambientY) * step) * damping

      vibe.vx = clampMagnitude(vibe.vx, 1.8)
      vibe.vy = clampMagnitude(vibe.vy, 1.8)

      vibe.x += vibe.vx * step
      vibe.y += vibe.vy * step
    })
  }

  getVibes() {
    return this.vibes
  }
}